"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SkuProductCard = _interopRequireDefault(require("./SkuProductCard"));

var _SkuCsvDownloadLink = _interopRequireDefault(require("./SkuCsvDownloadLink"));

var MAX_COUNT = 2;

var SkuProductCardList = function SkuProductCardList(_ref) {
  var skus = _ref.skus,
      getAccessToken = _ref.getAccessToken;
  return _react["default"].createElement(_react["default"].Fragment, null, skus.slice(0, MAX_COUNT).map(function (sku) {
    return _react["default"].createElement(_SkuProductCard["default"], {
      getAccessToken: getAccessToken,
      key: sku,
      sku: sku
    });
  }), skus.length > MAX_COUNT && _react["default"].createElement("div", null, "...and ", skus.length - MAX_COUNT, " more.", ' ', _react["default"].createElement(_SkuCsvDownloadLink["default"], {
    message: "Click here to Download all the SKUs",
    skus: skus
  })));
};

var _default = SkuProductCardList;
exports["default"] = _default;